import { render, staticRenderFns } from "./LoadingCircular.vue?vue&type=template&id=2a10b156&scoped=true"
import script from "./LoadingCircular.vue?vue&type=script&lang=ts"
export * from "./LoadingCircular.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a10b156",
  null
  
)

export default component.exports